import { createSelector } from "reselect";

export const currentUserSelector = createSelector(
  (state) => state.currentUser,
  (currentUser) => currentUser
);

export const currentUserCompanySelector = createSelector(
  currentUserSelector,
  (currentUser) => currentUser.company
);

export const defaultUnitsSelector = createSelector(
  currentUserCompanySelector,
  ({ currency, period, sizeUnit }) => ({ currency, period, sizeUnit })
);

export const isAccountHolderSelector = createSelector(
  currentUserSelector,
  (currentUser) => currentUser.roleInCompany === "account_holder"
);

export const isAdministratorSelector = createSelector(
  currentUserSelector,
  (currentUser) => currentUser.roleInCompany === "administrator"
);

export const isInternalSelector = createSelector(
  currentUserSelector,
  (currentUser) => currentUser.roleInCompany === "internal_user"
);

export const isBrokerSelector = createSelector(
  currentUserCompanySelector,
  (company) => company.role === "broker"
);

export const isOwnerSelector = createSelector(
  currentUserCompanySelector,
  (company) => company.role === "owner"
);

export const companyTypeSelector = createSelector(
  currentUserCompanySelector,
  (company) => company.type
);

export default defaultUnitsSelector;
